module.exports = __webpack_public_path__ + "r-v3/img/user_profile.664438b9.svg";